<template>
  <div class="card card--white small-space small-top">
    <div class="card card--container">
      <div>
        <span class="exercise-header">
          <span class="short-description clickable" @click="$emit('edit')">
            <button :icon='true' >
              <h-icon>edit</h-icon>
            </button>
            <span>{{ exercise.short_description }}</span>
          </span>
          <button v-if="editable" flat  @click="$emit('removeExercise', exercise)">
            <h-icon>delete</h-icon>
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import User from "@/services/api/authUser";
export default {
  props: ["exercise", "trashText", "editable"],
  data() {
    return {
      userId: User.id
    };
  },
  components: {
  }
};
</script>

<style>
.exercise-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
